
import API from '@/api/api_sign'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
created(){
this.dos();
},
directives: {
TransferDom
},
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Loading,
XButton,
Box,
Toast,
XDialog,CheckIcon
},
data () {
return {
show:false,
datas:{},
bankNo:'',
flowId:'',
code: '',
codeVal: '获取验证码',
codeFlog: false,
wait: 60,
show:false,
isagree:false,
}
},
methods: {
dos(){
API.psnInfo().then((res)=>{
if (res.code == '000000') {
this.datas = res.data;
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})

},
submit(){
if (this.bankNo === "") {
this.$vux.toast.show({
type:'cancel;',
text:'银行卡号不能为空'
});
return;
}
if (this.authNo === "") {
this.$vux.toast.show({
type:'cancel;',
text:'银行卡号错误'
});
return;
}
if (this.code === "") {
this.$vux.toast.show({
type:'cancel;',
text:'验证码不能为空'
});
return;
}

if(this.isagree==false){
this.$vux.toast.show({
type:'cancel;',
text:'请勾选协议'
});
return;
}
let param = new FormData();
param.append("flowId",this.flowId);
param.append("code",this.code);
API.validateCode(param).then((res)=>{
if (res.code == '000000') {
this.$router.push('/checksuc');
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},
getCode(){
if (this.codeFlog)return;
if(this.bankNo !=="" ){
let param = new FormData();
param.append("bankNo",this.bankNo);
API.psnCode(param).then(res => {
if (res.code == '000000') {
this.flowId = res.data.flowId;
this.time();
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
});
}else{
this.$vux.toast.show({
type:'cancel;',
text:'银行卡号不能为空'
});
}
},
time() {
if (this.wait === 0) {
this.codeFlog = false;
this.codeVal = "获取验证码";
this.wait = 60;
} else {
this.codeFlog = true;
this.codeVal = "重新发送(" + this.wait + ")";
this.wait--;
setTimeout( () =>{
this.time()
}, 1000);
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/check.vue